import { render, staticRenderFns } from "./NewPropertiesChart.vue?vue&type=template&id=46f422f6&scoped=true&"
import script from "./NewPropertiesChart.vue?vue&type=script&lang=js&"
export * from "./NewPropertiesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f422f6",
  null
  
)

export default component.exports